export const PIN_POPUP_TYPE = {
    pin: 1,
    confirm: 2
};
